import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { NoteModalComponent } from '../installation/sticky-panel/note-card/note-modal/note-modal.component';

@Injectable({
  providedIn: 'root',
})
export class NoteService {
  noteDialogRef: MatDialogRef<NoteModalComponent>;

  constructor(private dialog: MatDialog) {}

  showNoteModal(installationId: string, note?: string): void {
    this.noteDialogRef = this.dialog.open(NoteModalComponent, {
      width: '450px',
      data: {
        installationId,
        note,
      },
    });
  }
}
